import { Box } from "@mui/material";

import {
  CHAT_MEDIA_MAX_HEIGHT_PX,
  CHAT_MEDIA_MAX_SIZE_PX,
} from "@/components/molecules/ChatBalloon/media-size";
import { isValidUrl } from "@/helpers/url-validation";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";

import ChatImagePreview from "./ChatImagePreview";

const IMAGE_STYLE = {
  display: "block",
  width: "auto",
  height: "auto",
  maxWidth: "100%",
  maxHeight: CHAT_MEDIA_MAX_HEIGHT_PX,
  objectFit: "contain" as const,
  objectPosition: "center",
  borderRadius: 8,
};

type ChatRemoteMediaProps = {
  url: string;
  type?: string;
  alt?: string;
  messages: CurrentChatMessages;
};

function fileNameFromUrl(url: string): string {
  try {
    const lastSegment = new URL(url).pathname.split("/").filter(Boolean).pop();
    return lastSegment ? decodeURIComponent(lastSegment) : "imagem";
  } catch {
    return "imagem";
  }
}

export default function ChatRemoteMedia({ url, type, alt, messages }: ChatRemoteMediaProps) {
  if (!isValidUrl(url)) return null;

  const mediaKind = type?.split("/")[0];
  if (mediaKind === "video") {
    return (
      <Box mb={1}>
        <video
          controls
          src={url}
          style={{
            maxWidth: CHAT_MEDIA_MAX_SIZE_PX,
            maxHeight: CHAT_MEDIA_MAX_SIZE_PX,
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </Box>
    );
  }

  return (
    <Box mb={1}>
      <ChatImagePreview
        src={url}
        alt={alt || ""}
        fileName={fileNameFromUrl(url)}
        thumbnailStyle={IMAGE_STYLE}
        messages={messages}
      />
    </Box>
  );
}
